import { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import createCache from '@emotion/cache'
import { ThemeProvider } from '@mui/material/styles'
import { CacheProvider } from '@emotion/react'
import CssBaseline from '@mui/material/CssBaseline'
import Box from '@mui/material/Box'
import Footer from './Footer/Footer'
import Header from './Header/Header'
import HelmetMeta from './HelmetMeta'
import LanguageSwitcher from '../i18n/LanguageSwitcher'
import { analytics } from '../analytics'
import { applyTheme } from './ThemeCustomizer/theamer'
import Main from './Router/main.js'
import { DataProvider } from '../context/DataContext'
import '../i18n'
import './App.css'
// import './activateSW.js'

export default function App () {
  const { pathname } = useLocation()
  const { i18n, t } = useTranslation('common')
  const isAdminRoute = pathname.startsWith('/admin')

  const dir = i18n.resolvedLanguage === 'ar' ? 'rtl' : 'ltr'
  const activeTheme = useMemo(() => applyTheme(dir), [dir])

  // useEffect(() => {
  //   navigator.serviceWorker?.register('sw.js') // .then(function (registration) { console.log('Excellent, registered with scope: ', registration.scope) })
  // }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    // document.documentElement.scrollTop = 0
    // document.scrollingElement.scrollTop = 0
    analytics.page(window.location.pathname)
  }, [pathname])

  const emotionCache = createCache({
    key: 'ecns', // emotion-cache-no-speedy
    speedy: false
  })

  return (
    <ThemeProvider theme={activeTheme}>
      <CacheProvider value={emotionCache}>
        <CssBaseline />
        <HelmetMeta />

        {!isAdminRoute && <Header />}

        {!isAdminRoute && <LanguageSwitcher />}

        <Box sx={{ minHeight: '72vh' }}>
          <DataProvider>
            <Main />
          </DataProvider>
        </Box>

        {!isAdminRoute && (
          <Box
            sx={{
              pt: 6,
              px: 1,
              mt: 6
            }}
          >
            <Footer />
          </Box>
        )}

        {/* Fixed mountain image at bottom of screen */}
        <Box
          component='img'
          src='https://d1hi0tbu2kom2c.cloudfront.net/img/mount.png'
          alt={t('mountainAlt')}
          sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            width: '100vw',
            height: 'auto',
            zIndex: -1,
            pointerEvents: 'none',
            userSelect: 'none'
          }}
        />
      </CacheProvider>
    </ThemeProvider>
  )
}
